import React from "react";
import { useState } from "react";
import logger from "../../utils/logger";
const WellnessBadges = ({ badges }) => {
  const badgesList = [
    "Active",
    "Courage",
    "Creative",
    "Determined",
    "Explorer",
    "Kindness",
    "Learner",
    "Positive",
    "Strengths",
    "Thankful",
  ];

  const badgesDescriptionMapping = {
    Active:
      "Earn this badge by choosing an active wellness practice like stretching or moving your body 20 times",
    Creative:
      "Earn this badge for choosing “other” as your wellness practice 20 times and creating wellness in your own way",
    Courage:
      "Earn this badge for having the courage to feel 5 different emotions in a month. After all, we all experience different emotions.",
    Determined:
      "Earn this badge for feeling your emotions 50 times in a month (practicing 50 times in a month)",
    Explorer:
      "Earn this badge for trying 5 different wellness practices in a month",
    Kindness:
      "Earn this badge by choosing a wellness practice that spreads kindness to others 10 times (Examples: Help others, give someone a compliment)",
    Learner:
      "Earn this badge by practicing a thoughtful wellness practice 15 times (Examples: Write in my journal, Use my growth mindset, Remember that difficult times pass and I’m not alone, Remind myself of two good things)",
    Positive:
      "Earn this badge by choosing wellness practices that promote positivity with yourself 20 times (Examples: Smile, Imagine a peaceful place, Imagine positive things in the future, Remember that difficult times pass and I'm not alone, Remind myself of two good things).",
    Strengths:
      "Earn this badge for choosing the same wellness practice 20 times. This shows that you are learning what wellness practices help make you strong.",
    Thankful:
      "Earn this badge for practicing being grateful as your wellness practice 10 times",
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-3 w-full">
      {badgesList.map((badge, index) => {
        const earnedCount = badges?.[badge.toLowerCase()] || 0;
        const capitalizedBadge = badge.charAt(0).toUpperCase() + badge.slice(1);
        const description =
          earnedCount > 0
            ? `You have earned this badge ${earnedCount} time${
                earnedCount > 1 ? "s" : ""
              }.`
            : "Keep practicing wellness to earn this badge.";
        const fullDescription = `${description}\n\n${badgesDescriptionMapping[capitalizedBadge]}`
        // const fullDescription = `${badgesDescriptionMapping[capitalizedBadge]}`;

        return (
          <div
            key={index}
            className={`flex flex-row items-start justify-between gap-2 px-2 py-2 sm:py-3 ${
              earnedCount > 0 ? "bg-[#FFFCE6] border border-[#D4AF37]" : "bg-[#E0E3E8]"
            }`}
          >
            <img
              src={`../images/badges/${
                earnedCount > 0 ? "color" : "grey"
              }/${badge}Badge${earnedCount > 0 ? "Color" : "Grey"}.png`}
              alt={badge}
              className="w-12 h-auto cursor-pointer"
            />
            <div className="flex flex-col">
              <p className="font-semibold capitalize text-[16px]">
                {badge} Badge {earnedCount > 0 ? `(${earnedCount}x)` : ""}
              </p>
              <p className="text-[12px] whitespace-pre-line">
                {fullDescription}{" "}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WellnessBadges;
